<!--首页-->
<template>
  <div class="gray-back" style="height: 100%">
    <div class="box"  >
      <div class="news-content" style="padding: 0 10px;">
        <video width="100%" v-if="row.files.length>0"  controls="controls" :src="row.files[0].url" :poster="row.pic_url" ></video>
      </div> 



    <div class="news-content" v-html="row.content">
    </div>

    </div>
  </div>
</template>
<style scoped>

.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}
  .row1{
    /*padding: 10px;*/
    margin: 0 10px;
  }
  .row1 img{
    width: 100%;
    margin: 10px 0 0 0 ;
  }
  .row3{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 10px;
    flex-wrap: wrap;
  }
  .row3 img{
    float: left;
    width: calc(33.33% - 10px);
    /*margin: 0 10px 10px 0;*/
    margin: 0 0px 10px 0;
  }

.news-content {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 20px;
  color: rgba(34, 34, 34, 1);
  line-height: 28px;
}

.news-content >>> img {
  max-width: 100% !important;
}

.news-content >>> video {
  max-width: 100% !important;
}

</style>

<script>
import Vue from "vue";
import { Tab, Tabs, List, PullRefresh, Toast } from "vant";
Vue.use(Tab)
  .use(Tabs)
  .use(PullRefresh)
  .use(List)
  .use(Toast);

export default {
  name: "NewsList",
  components: {
  },

  data: function() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      active: 0,
      row:{
        files:[]
      },
      activeTab: [
      ],
      list:[],
      params:{
        id:0
      },
    };
  },
  filters: {
  },
  mounted() {
    document.title = "331专题";
    this.params.id = this.$route.query.id
    this.fetch();
  },
  destroyed() {},
  methods: {
    fetch() {
      let that = this;
      that.$api.get(
              "/api/cms/detail",
              that.params,
              res => {
                that.row = res.data.data
              },
              res => {
                Toast(res.msg);
              }
      );
    },
  }
};
</script>



// WEBPACK FOOTER //
// 331.vue?a8decda2